import ko from 'knockout'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import { FieldViewModel } from './FieldViewModel'
import { MultiFieldViewModel } from './MultiFieldViewModel'
import fieldTemplate from './field.tpl.html'
import multiFieldTemplate from './multi.field.tpl.html'

interface Params {
  raceKey: ObservableRaceKey
  bettingContext: BettingInformation
}

if (!ko.components.isRegistered('single-field')) {
  ko.components.register('single-field', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new FieldViewModel(params)
        return viewModel
      },
    },
    template: fieldTemplate,
  })
}

if (!ko.components.isRegistered('multi-field')) {
  ko.components.register('multi-field', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new MultiFieldViewModel(params)
        return viewModel
      },
    },
    template: multiFieldTemplate,
  })
}
